<div class="ecb-participant-registration-page">


  <!-- =========================================================
       Loading
  ========================================================== -->
  <div class="ecb-registration-message ecb-registration-loading" *ngIf="isLoading">

    <span class="spinner-border spinner-border-sm">
    </span>

    <span>
      Loading participant registration details...
    </span>

  </div>


  <!-- =========================================================
       Main Page
  ========================================================== -->
  <div class="ecb-participant-registration-container" *ngIf="!isLoading && !loadErrorMessage">


    <!-- =======================================================
         Header
    ======================================================== -->
    <header class="ecb-registration-header">

      <div class="ecb-registration-header-icon">

        <i class="bi bi-person-check"></i>

      </div>


      <div class="ecb-registration-header-content">

        <span class="ecb-registration-eyebrow">
          Participant Registration
        </span>

        <h1>
          Complete Your Training Registration
        </h1>

        <p>
          Confirm your details and provide the required education,
          qualification and identity documents.
        </p>

      </div>


      <div class="ecb-registration-reference">

        <span>
          Reference
        </span>

        <strong>
          {{ReferencePrefix}}{{ enquiryId }}
        </strong>

        <small>
          Participant {{ participant.participantNo }}
        </small>

      </div>

    </header>


    <!-- =======================================================
         Booking Summary
    ======================================================== -->
    <section class="ecb-registration-summary-card">


      <div class="ecb-registration-summary-item" *ngIf="this.type==''">

        <span class="ecb-registration-summary-icon">

          <i class="bi bi-building"></i>

        </span>

        <div>

          <small>
            Company
          </small>

          <strong>
            {{ companyName || '-' }}


          </strong>

        </div>

      </div>


      <div class="ecb-registration-summary-item" *ngIf="this.type==''">

        <span class="ecb-registration-summary-icon">

          <i class="bi bi-calendar-event"></i>

        </span>

        <div>

          <small>
            Training Required Date
          </small>

          <strong>
            {{ getTrainingDateDisplay() }}

          </strong>

        </div>

      </div>


      <div class="ecb-registration-summary-item">

        <span class="ecb-registration-summary-icon">

          <i class="bi bi-person"></i>

        </span>

        <div>

          <small>
            Participant
          </small>

          <strong>
            {{ participant.fullName || '-' }}
          </strong>

        </div>

      </div>

    </section>


    <!-- =======================================================
         Selected Training
    ======================================================== -->
    <section class="ecb-registration-card">

      <div class="ecb-registration-card-header">

        <div class="ecb-registration-card-title">

          <span class="ecb-registration-card-icon">

            <i class="bi bi-mortarboard"></i>

          </span>


          <div>

            <h2>
              Selected Training
            </h2>

            <p>
              Courses selected for this participant.
            </p>

          </div>

        </div>

      </div>


      <div class="ecb-registration-card-body">

        <div class="ecb-selected-course-list" *ngIf="selectedCourses.length; else noSelectedCourses">

          <div class="ecb-selected-course" *ngFor="let course of selectedCourses">

            <span class="ecb-course-type" [class.voc]="course.courseType === 'VOC'"
              [class.coa]="course.courseType === 'COA'">

              {{ course.courseType || 'COURSE' }}

            </span>


            <div class="ecb-selected-course-content">

              <strong *ngIf="course.courseCode">

                {{ course.courseCode }}

              </strong>

              <span>
                {{ course.courseName || '-' }}
              </span>

            </div>

          </div>

        </div>


        <ng-template #noSelectedCourses>

          <div class="ecb-empty-training">

            No selected training was returned for this participant.

          </div>

        </ng-template>

      </div>

    </section>


    <!-- =======================================================
         Participant Details
    ======================================================== -->
    <section class="ecb-registration-card">

      <div class="ecb-registration-card-header">

        <div class="ecb-registration-card-title">

          <span class="ecb-registration-card-icon">

            <i class="bi bi-person"></i>

          </span>

          <div>

            <h2>
              Participant Details
            </h2>

          </div>

        </div>

      </div>


      <div class="ecb-registration-card-body">

        <div class="row g-4">


          <!-- First Name -->
          <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                First Name
                <span>*</span>
              </label>

              <input type="text" class="form-control" maxlength="100" [(ngModel)]="participant.firstName"
                name="firstName" placeholder="Enter first name">

            </div>

          </div>


          <!-- Last Name -->
          <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                Last Name
                <span>*</span>
              </label>

              <input type="text" class="form-control" maxlength="100" [(ngModel)]="participant.lastName" name="lastName"
                placeholder="Enter last name">

            </div>

          </div>


          <!-- DOB -->
          <div class="col-12 col-md-4">

            <div class="ecb-registration-form-group">

              <label>
                Date of Birth
              </label>

              <input type="date" [max]="yesterdayDate" class="form-control" [(ngModel)]="participant.dateOfBirth"
                name="dateOfBirth">

            </div>

          </div>


          <!-- Email -->
          <div class="col-12 col-md-4">

            <div class="ecb-registration-form-group">

              <label>
                Email Address
                <span>*</span>
              </label>

              <input type="email" class="form-control" maxlength="100" [(ngModel)]="participant.emailAddress"
                name="emailAddress" placeholder="Enter email address" appEmailValidator #participantEmailCtrl="ngModel">


              <div class="ecb-registration-field-error" *ngIf="
                  participantEmailCtrl.invalid &&
                  (
                    participantEmailCtrl.dirty ||
                    participantEmailCtrl.touched
                  )
                ">

                <span *ngIf="
                    participantEmailCtrl.errors?.['invalidEmail']
                  ">

                  Please enter a valid email address.

                </span>

              </div>

            </div>

          </div>


          <!-- Mobile -->
          <div class="col-12 col-md-4">

            <div class="ecb-registration-form-group">

              <label>
                Contact Number
                <span>*</span>
              </label>

              <input type="tel" class="form-control" appPhoneNumberValidation [(ngModel)]="participant.mobileNumber"
                name="mobileNumber" placeholder="Enter contact number">

            </div>

          </div>


          <!-- Address -->
          <div class="col-12">

            <div class="ecb-registration-form-group">

              <label>
                Address
              </label>

              <textarea class="form-control ecb-registration-address" maxlength="500" rows="3"
                [(ngModel)]="participant.address" name="address" placeholder="Enter residential address">
              </textarea>

            </div>

          </div>


        </div>

      </div>

    </section>


    <!-- =======================================================
         EDUCATION*ngIf="showUSI"
    ======================================================== -->
    <section class="ecb-registration-card">

      <div class="ecb-registration-card-header">

        <div class="ecb-registration-card-title">

          <span class="ecb-registration-card-icon">

            <i class="bi bi-book"></i>

          </span>


          <div>

            <h2>
              Education
            </h2>

            <p>
              Select your highest qualification.
            </p>

          </div>

        </div>

      </div>


      <div class="ecb-registration-card-body">

        <div class="row g-4">


          <!-- Qualification -->
          <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                Education
              </label>


              <select class="form-select" [(ngModel)]="participant.qualificationId" name="educationQualificationId"
                (ngModelChange)="
                  onEducationQualificationChange($event)
                ">

                <option [ngValue]="null">

                  Select highest education

                </option>


                <option *ngFor="
                    let qualification of qualificationList
                  " [ngValue]="qualification.id">

                  {{ qualification.qualificationName }}

                </option>

              </select>

              <div class="ecb-course-booking-added-item" *ngIf="participant.qualificationName">

                <div>

                  <i class="bi bi-check-square-fill"></i>

                  <span>

                    <strong>
                      Selected:
                    </strong>




                    {{ participant.qualificationName }}




                  </span>

                </div>
              </div>

            </div>

          </div>


          <!-- USI -->
          <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                USI
              </label>

              <input type="text" class="form-control" maxlength="20" [(ngModel)]="participant.usi" name="usi"
                placeholder="Enter USI">

            </div>

          </div>




        </div>

      </div>

    </section>


    <!-- =======================================================
         QUALIFICATION
    ======================================================== -->
    <section class="ecb-registration-card">

      <div class="ecb-registration-card-header">

        <div class="ecb-registration-card-title">

          <span class="ecb-registration-card-icon">

            <i class="bi bi-award"></i>

          </span>


          <div>

            <h2>
              Qualification
            </h2>

            <p>
              Enter any relevant qualification and upload supporting evidence.
            </p>

          </div>

        </div>

      </div>


      <div class="ecb-registration-card-body">

        <div class="row g-4">


          <!-- Relevant Qualification -->
          <!-- <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                Relevant Qualification / Competency
              </label>

              <input
                type="text"
                class="form-control"
                maxlength="100"
                [(ngModel)]="participant.relevantQualification"
                name="relevantQualification"
                placeholder="Enter qualification">

            </div>

          </div> -->


          <!-- Certificate Number -->
          <!-- <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                Certificate Number
              </label>

              <input
                type="text"
                class="form-control"
                maxlength="100"
                [(ngModel)]="
                  participant.qualificationCertificateNumber
                "
                name="qualificationCertificateNumber"
                placeholder="Enter certificate number">

            </div>

          </div> -->


          <!-- Organisation -->
          <!--   <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                Issuing RTO / Organisation
              </label>

              <input
                type="text"
                class="form-control"
                maxlength="100"
                [(ngModel)]="participant.issuingOrganisation"
                name="issuingOrganisation"
                placeholder="Enter issuing organisation">

            </div>

          </div> -->


          <!-- Date -->
          <!-- <div class="col-12 col-md-6">

            <div class="ecb-registration-form-group">

              <label>
                Date Issued / Expiry
              </label>

              <input
                type="date"
                class="form-control"
                [(ngModel)]="participant.dateIssuedExpiry"
                name="dateIssuedExpiry">

            </div>

          </div> -->


          <!-- Certificate Available -->
          <!--  <div class="col-12">

            <div class="ecb-registration-form-group">

              <label>
                Certificate Available
              </label>


              <div class="ecb-registration-choice-group">


                <label>

                  <input
                    type="radio"
                    name="certificateAvailable"
                    [value]="true"
                    [(ngModel)]="
                      participant.certificateAvailable
                    "
                    (ngModelChange)="
                      onCertificateAvailableChange()
                    ">

                  <span>
                    Yes
                  </span>

                </label>


                <label>

                  <input
                    type="radio"
                    name="certificateAvailable"
                    [value]="false"
                    [(ngModel)]="
                      participant.certificateAvailable
                    "
                    (ngModelChange)="
                      onCertificateAvailableChange()
                    ">

                  <span>
                    No
                  </span>

                </label>


              </div>

            </div>

          </div> -->


          <!-- ===================================================
               MULTIPLE CERTIFICATES
          ==================================================== -->
          <!-- =======================================================
     Qualification Certificates
======================================================== -->
          <div class="col-12">

            <div class="ecb-registration-form-group">

              <label>
                Qualification Certificates
              </label>


              <!-- Hidden File Input -->
              <input #certificateFileInput type="file" hidden multiple
                accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp"
                [disabled]="participant.isCertificateUploading" (change)="onCertificateFilesSelected($event)">


              <!-- ===============================================
         Uploaded Certificates
    ================================================ -->
              <div *ngFor="
        let certificate of participant.certificates;
        let certificateIndex = index
      " class="ecb-registration-upload-box mb-3">


                <div class="
          d-flex
          justify-content-between
          align-items-center
          mb-3
        ">

                  <strong>
                    Certificate {{ certificateIndex + 1 }}
                  </strong>


                  <button type="button" class="btn btn-sm btn-outline-danger"
                    [disabled]="participant.isCertificateUploading" (click)="removeCertificate(certificateIndex)">

                    <i class="bi bi-trash"></i>

                    Remove

                  </button>

                </div>


                <!-- Uploaded File -->
                <div class="ecb-registration-uploaded-file">

                  <i class="bi bi-file-earmark-check"></i>


                  <div>

                    <strong>
                      {{ certificate.fileName }}
                    </strong>

                    <span *ngIf="certificate.fileUrl">
                      Upload complete
                    </span>

                  </div>

                </div>

              </div>


              <!-- ===============================================
         Add Certificate Button
    ================================================ -->
              <div class="ecb-registration-upload-box">


                <button type="button" class="ecb-registration-upload-button"
                  [disabled]="participant.isCertificateUploading" (click)="certificateFileInput.click()">


                  <ng-container *ngIf="!participant.isCertificateUploading">

                    <i class="bi bi-plus-circle"></i>

                    Add a Certificate

                  </ng-container>


                  <ng-container *ngIf="participant.isCertificateUploading">

                    <span class="spinner-border spinner-border-sm"></span>

                    Uploading...

                  </ng-container>


                </button>


                <!-- Upload Error -->
                <div class="ecb-registration-upload-error" *ngIf="participant.certificateUploadError">

                  <i class="bi bi-exclamation-circle"></i>

                  {{ participant.certificateUploadError }}

                </div>


              </div>

            </div>

          </div>


        </div>

      </div>

    </section>


    <!-- =======================================================
         IDENTITY / VERIFICATION
    ======================================================== -->
    <section class="ecb-registration-card ecb-identity-section">

      <div class="ecb-registration-card-header">

        <div class="ecb-registration-card-title">

          <span class="ecb-registration-card-icon">

            <i class="bi bi-person-vcard"></i>

          </span>


          <div>

            <h2>
              Verification
            </h2>

            <p>
              Add one or more identity documents.
            </p>

          </div>

        </div>

      </div>


      <div class="ecb-registration-card-body">


        <!-- ===================================================
             MULTIPLE IDENTITIES
        ==================================================== -->
        <div *ngFor="
            let identity of participant.identities;
            let identityIndex = index
          " class="mb-4">


          <!-- Identity Heading -->
          <div class="
              d-flex
              justify-content-between
              align-items-center
              mb-3
            ">

            <strong>

              ID Document
              {{ identityIndex + 1 }}

            </strong>


            <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="
                participant.identities.length > 1
              " [disabled]="
                identity.isUploading ||
                identity.isReading
              " (click)="
                removeIdentity(
                  identityIndex
                )
              ">

              <i class="bi bi-trash"></i>

              Remove ID

            </button>

          </div>


          <!-- OCR Reading -->
          <div class="ecb-identity-reading mb-3" *ngIf="identity.isReading">

            <span class="spinner-border spinner-border-sm">
            </span>

            <div>

              <strong>
                Reading ID details...
              </strong>

              <span>

                Detecting document information...

                {{ identity.ocrProgress }}%

              </span>

            </div>

          </div>


          <div class="row g-4">


            <!-- ID Type -->
            <div class="col-12 col-lg-4">

              <div class="row g-3">


                <div class="col-12">

                  <div class="ecb-registration-form-group">

                    <label>
                      ID Type
                    </label>


                    <!-- <select class="form-select" [(ngModel)]="
                        identity.idType
                      " [name]="
                        'idType_' +
                        identityIndex
                      " [disabled]="
                        identity.isReading
                      ">

                      <option value="">
                        Select ID type
                      </option>

                      <option value="DRIVER_LICENCE">
                        Driver Licence
                      </option>

                      <option value="PASSPORT">
                        Passport
                      </option>

                      <option value="PROOF_OF_AGE">
                        Proof of Age
                      </option>

                      <option value="OTHER">
                        Other
                      </option>

                    </select> -->

                    <select class="form-select" [(ngModel)]="identity.idType" [name]="'idType_' + identityIndex"
                      [disabled]="identity.isReading">

                      <option value="">
                        Select ID type
                      </option>

                      <option *ngFor="let idType of identityTypesList" [value]="idType.code">
                        {{ idType.name }}
                      </option>

                    </select>

                  </div>

                </div>


                <!-- ID Number -->
                <!--       <div class="col-12">

                  <div class="ecb-registration-form-group">

                    <label>
                      ID Number
                    </label>

                    <input type="text" class="form-control" maxlength="50" [(ngModel)]="
                        identity.idNumber
                      " [name]="
                        'idNumber_' +
                        identityIndex
                      " placeholder="Enter ID number" [disabled]="
                        !identity.idType ||
                        identity.isReading
                      ">

                  </div>

                </div> -->


                <!-- Expiry Date -->
                <!--    <div class="col-12">

                  <div class="ecb-registration-form-group">

                    <label>
                      Expiry Date
                    </label>

                    <input type="date" class="form-control" [(ngModel)]="
                        identity.expiryDate
                      " [name]="
                        'idExpiryDate_' +
                        identityIndex
                      " [disabled]="
                        !identity.idType ||
                        identity.isReading
                      ">

                  </div>

                </div>
 -->

                <!-- Nationality -->
                <!--   <div class="col-12">

                  <div class="ecb-registration-form-group">

                    <label>
                      Nationality
                    </label>

                    <input type="text" class="form-control" maxlength="100" [(ngModel)]="
                        identity.nationality
                      " [name]="
                        'nationality_' +
                        identityIndex
                      " placeholder="Enter nationality" [disabled]="
                        !identity.idType ||
                        identity.isReading
                      ">

                  </div>

                </div>

 -->
              </div>

            </div>


            <!-- =================================================
                 ID DOCUMENT
            ================================================== -->
            <div class="col-12 col-lg-8">

              <div class="ecb-registration-form-group">

                <label>
                  ID Document
                </label>


                <input #idFileInput type="file" hidden accept="
                    .pdf,
                    .jpg,
                    .jpeg,
                    .png,
                    .webp,
                    application/pdf,
                    image/jpeg,
                    image/png,
                    image/webp
                  " [disabled]="
                    !identity.idType ||
                    identity.isUploading ||
                    identity.isReading
                  " (change)="
                    onIdFileSelected(
                      $event,
                      identityIndex
                    )
                  ">


                <div class="
                    ecb-registration-upload-box
                    ecb-id-upload-box
                  ">


                  <button type="button" class="ecb-registration-upload-button" [disabled]="
                      !identity.idType ||
                      identity.isUploading ||
                      identity.isReading
                    " (click)="
                      idFileInput.click()
                    ">


                    <!-- Select ID Type -->
                    <ng-container *ngIf="
                        !identity.idType &&
                        !identity.isUploading &&
                        !identity.isReading
                      ">

                      <i class="bi bi-person-vcard"></i>

                      Select ID Type First

                    </ng-container>


                    <!-- Upload -->
                    <ng-container *ngIf="
                        identity.idType &&
                        !identity.isUploading &&
                        !identity.isReading
                      ">

                      <i class="bi bi-cloud-arrow-up"></i>

                      {{
                      identity.fileName
                      ? 'Replace ID Document'
                      : 'Upload ID Document'
                      }}

                    </ng-container>


                    <!-- OCR -->
                    <ng-container *ngIf="identity.isReading">

                      <span class="spinner-border spinner-border-sm">
                      </span>

                      Reading ID...

                    </ng-container>


                    <!-- Uploading -->
                    <ng-container *ngIf="
                        identity.isUploading &&
                        !identity.isReading
                      ">

                      <span class="spinner-border spinner-border-sm">
                      </span>

                      Uploading...

                    </ng-container>


                  </button>


                  <!-- Uploaded ID -->
                  <div class="ecb-registration-uploaded-file" *ngIf="identity.fileName">

                    <i class="bi bi-person-vcard"></i>


                    <div>

                      <strong>

                        {{ identity.fileName }}

                      </strong>

                      <span *ngIf="
                          identity.fileUrl &&
                          !identity.isReading
                        ">

                        Upload complete

                      </span>

                    </div>


                    <button type="button" class="
                        btn
                        btn-sm
                        btn-outline-danger
                        ms-auto
                      " [disabled]="
                        identity.isUploading ||
                        identity.isReading
                      " (click)="
                        removeIdFile(
                          identityIndex
                        )
                      ">

                      <i class="bi bi-trash"></i>

                    </button>

                  </div>


                  <!-- Error -->
                  <div class="ecb-registration-upload-error" *ngIf="identity.uploadError">

                    <i class="bi bi-exclamation-circle"></i>

                    {{ identity.uploadError }}

                  </div>


                </div>

              </div>

            </div>


          </div>


          <hr *ngIf="
              identityIndex <
              participant.identities.length - 1
            " class="my-4">

        </div>


        <!-- Add Another ID -->
        <div class="mt-3">

          <button type="button" class="btn btn-outline-primary" (click)="addIdentity()">

            <i class="bi bi-plus-circle"></i>

            Add Another ID

          </button>

        </div>


      </div>

    </section>


    <!-- =======================================================
         Error
    ======================================================== -->
    <div class="alert alert-danger ecb-registration-message" *ngIf="errorMessage">

      <i class="bi bi-exclamation-circle-fill"></i>

      {{ errorMessage }}

    </div>


    <!-- =======================================================
         Success
    ======================================================== -->
    <div class="alert alert-success ecb-registration-message" *ngIf="successMessage">

      <i class="bi bi-check-circle-fill"></i>

      {{ successMessage }}

    </div>


    <!-- =======================================================
         Submitted Date
    ======================================================== -->
    <section class="
        ecb-registration-card
        ecb-submitted-date-card
      ">

      <div class="ecb-registration-card-body">

        <div class="row align-items-end g-3">


          <div class="col-12 col-md-5">

            <div class="ecb-registration-form-group">

              <label>
                Submitted Date
              </label>

              <input type="date" class="form-control" [(ngModel)]="submittedDate" name="submittedDate" readonly>

            </div>

          </div>


          <div class="col-12 col-md-7">

            <div class="ecb-submitted-date-note">

              <i class="bi bi-calendar-check"></i>

              <span>

                The submitted date is automatically set to the current date.

              </span>

            </div>

          </div>


        </div>

      </div>

    </section>


    <!-- =======================================================
         Submit
    ======================================================== -->
    <div class="ecb-registration-submit-card">


      <div class="ecb-registration-submit-info">

        <i class="bi bi-info-circle"></i>


        <div>

          <strong>
            Review before submitting
          </strong>

          <span>

            Confirm your details and uploaded qualification
            and ID documents.

          </span>

        </div>

      </div>


      <button type="button" class="btn ecb-registration-submit-button" [disabled]="
          isSubmitting ||
          hasUploadingFiles()
        " (click)="submitRegistration()">


        <ng-container *ngIf="!isSubmitting">

          <i class="bi bi-check-circle"></i>

          Submit Registration

        </ng-container>


        <ng-container *ngIf="isSubmitting">

          <span class="spinner-border spinner-border-sm">
          </span>

          Submitting...

        </ng-container>


      </button>

    </div>


  </div>


  <!-- =========================================================
       Load Error
  ========================================================== -->
  <div class="ecb-registration-state-card" *ngIf="
      !isLoading &&
      loadErrorMessage
    ">

    <div class="ecb-registration-state-icon error">

      <i class="bi bi-exclamation-triangle"></i>

    </div>


    <h3>
      Unable to load registration
    </h3>


    <p>
      {{ loadErrorMessage }}
    </p>

  </div>


</div>


<!--Start Confirmation massage -->
<p-dialog [(visible)]="showSuccessPopup" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [autoZIndex]="true" appendTo="body" [style]="{ width: '460px', maxWidth: '95vw' }">
  <div class="text-center p-3">

    <i class="bi bi-check-circle-fill" style="
        font-size: 52px;
        color: #e35d1a;
      ">
    </i>

    <h3 style="
        margin-top: 18px;
        color: #56302b;
      ">
      Thank you !
    </h3>

    <p style="
        margin-top: 12px;
        color: #555;
        line-height: 1.6;
      ">

      Your course form been sent,

      <br><br>

      returned to our homepage.

    </p>

    <button type="button" class="btn ecb-x-corporate-save-button mt-3" (click)="closeEnquirySuccessPopup()">

      OK

    </button>

  </div>

</p-dialog>

<!--End Confirmation massage -->